{
  "Clear search": "Keresés törlése"
}